import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";

const keywordChanges = [
  {
    action: "Inclusion",
    keyword: "sport betting sites",
    status: "added",
    adgroup: "Adgroup UK - Football Betting | Tier 2",
    matchType: "Exact",
    date: "24/02/2025",
  },
  {
    action: "Inclusion",
    keyword: "top 10 betting sites",
    status: "added",
    adgroup: "Adgroup UK - Betting Sites | Tier 3",
    matchType: "Exact",
    date: "21/02/2025",
  },
  {
    action: "Inclusion",
    keyword: "betting sites",
    status: "added",
    adgroup: "Adgroup UK - Best Betting Sites | Tier 3",
    matchType: "Exact",
    date: "17/02/2025",
  },
  {
    action: "Exclusion",
    keyword: "best football betting sites",
    status: "paused",
    adgroup: "Adgroup UK - Best Betting Sites | Tier 3",
    matchType: "Exact",
    date: "25/02/2025",
  },
  {
    action: "Exclusion",
    keyword: "top betting sites",
    status: "removed",
    adgroup:
      "Adgroup UK - Football Betting | Tier 2 → Adgroup UK - Betting Sites",
    matchType: "Exact",
    date: "24/02/2025",
  },
  {
    action: "Exclusion",
    keyword: "football betting",
    status: "removed",
    adgroup: "Adgroup UK → Adgroup UK - Betting Sites | Tier 3",
    matchType: "Exact",
    date: "20/02/2025",
  },
];

const AdditionalChanges = () => {
  return (
    <Paper sx={{ marginTop: "16px", padding: "8px 16px" }}>
      <Typography fontSize={24}>Additional Changes</Typography>
      <TableContainer sx={{mt: 1}}>
        <Table>
          <TableBody>
            {["Inclusion", "Exclusion"].map((section) => (
              <React.Fragment key={section}>
                {/* Section Header Row */}
                <TableRow>
                  <TableCell
                    colSpan={1}
                    sx={{padding: "6px 0px"}}
                  >
                    <Typography fontWeight={500}>
                      {section} of Keywords
                    </Typography>
                  </TableCell>
                </TableRow>

                {/* Data Rows */}
                {keywordChanges
                  .filter((row) => row.action === section)
                  .map((row, index) => (
                    <TableRow
                      key={`${section}-${index}`}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell sx={{ padding: "6px 0px" }}>
                        <Typography variant="body2">
                          The keyword{" "}
                          <Typography
                            component="span"
                            fontWeight={500}
                            color="secondary"
                          >
                            {row.keyword}
                          </Typography>{" "}
                          was{" "}
                          <Typography
                            component="span"
                            fontWeight={500}
                            color="secondary"
                          >
                            {row.action}
                          </Typography>{" "}
                          to the current Adgroup from Adgroup UK - Football
                          Betting | Tier 2 | Exact* on{" "}
                          <Typography
                            component="span"
                            fontWeight={500}
                            color="secondary"
                          >
                            {row.date}
                          </Typography>
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default AdditionalChanges;
